import * as S from './styles'
import { theme } from 'styles/theme/hav-theme'
import { Alert, Icon } from 'components'
import { OverviewValue } from '../../../components/ModalOrderOverview/components'
import { numberToDecimalString as toDec } from 'commons/utils/number'
import { useSelector } from 'store/store'

export const OverviewContent = () => {
  const {
    generatedEdiOrders: {
      id_prcs_edi: idEdi,
      pedido_total: totalOrders,
      pedido_volume_pares: orderVolume,
      pedido_valor_total: orderValue,
      ordem_volume_pares: ovVolume,
      ordem_total: totalOvs,
      ordem_valor_total: ovsValue,
      volume_pares_aberto: pendingVolume,
      total_valor_aberto: pendingValue
    }
  } = useSelector((state) => state.batchOrder)

  return (
    <div>
      <S.DescriptionContainer>
        <Alert
          kind="success"
          title={'OVs geradas com sucesso!'}
          message="Para acompanhá-las, acesse a área de gerenciamento."
          fullWidth
        />
        <span>
          Os pedidos gerados têm o número EDI <b>#{idEdi ?? ''}</b>. Confira abaixo a
          distribuição dos materiais:
        </span>
      </S.DescriptionContainer>
      <S.OverviewValues>
        <OverviewValue
          icon={<Icon icon="box" color={theme.colors.primary.main} size="16" />}
          title="Pedidos gerados"
          subtitle={`${toDec(orderVolume ?? 0)} pares -> ${toDec(
            totalOrders ?? 0
          )} pedidos`}
          tooltip='Os pedidos gerados correspondem aos materiais solicitados, porém podem ter originado OVs ou ainda estar com status de "Em aberto".'
          value={orderValue}
          iconColorBackground={theme.colors.alert.info.ligther}
        />
        <OverviewValue
          icon={<Icon icon="task-alt" color={theme.colors.alert.success[30]} size="16" />}
          title="OVs geradas"
          subtitle={`${toDec(ovVolume ?? 0)} pares -> ${toDec(totalOvs ?? 0)} ${
            totalOvs === 1 ? 'ov' : 'ovs'
          }`}
          tooltip="Materiais que atendem aos requisitos de cota, estoque e/ou valor mínimo, que estão aptos para gerar OVs e serem enviados ao SAP. "
          value={ovsValue}
          iconColorBackground={theme.colors.alert.success[10]}
        />
        <OverviewValue
          icon={<Icon icon="edit" color={theme.colors.neutral[60]} size="16" />}
          title="Em aberto"
          subtitle={`${toDec(pendingVolume ?? 0)} pares`}
          tooltip="Materiais que não geraram OVs durante a transação."
          value={pendingValue}
          iconColorBackground={theme.colors.neutral.wrapicon}
        />
      </S.OverviewValues>
    </div>
  )
}
